import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CatStoriesComponent } from './cat-stories.component';



const routes: Routes = [
  { path: '', component: CatStoriesComponent }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CatStoriesRoutingModule {}
